import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export function Loading() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <FontAwesomeIcon icon={faSpinner} className="animate-spin text-blue-500" size="2x" />
    </div>
  );
}
